import { HttpClient } from '@angular/common/http';
import { appSettings } from '@nha/config';
import { IApiConfig } from '../interfaces/iapi-config.interface';

export abstract class ApiConfig implements IApiConfig {
	constructor(private _httpClient: HttpClient, private _apiName: string, private _useLegacy: boolean = false) {}

	getApiName(): string {
		return this._apiName;
	}

	getBaseUrl(): string {
		if (this.isLegacy()) {
			return appSettings.legacyApi[this._apiName];
		}
		return appSettings.api[this._apiName];
	}

	isLegacy(): boolean {
		return this._useLegacy;
	}

	getHttpClient(): HttpClient {
		return this._httpClient;
	}
}
